import { Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'vnm-flex-container',
  templateUrl: './flex-container.component.html',
  styleUrls: ['./flex-container.component.scss']
})
export class FlexContainerComponent {
  @HostBinding('attr.style')
  get inputsAsStyle(): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`
      --direction: ${this.direction};
      --gap: ${this.gap};
      --wrap: ${this.wrap};
      --justify: ${this.justify};
    `);
  }

  @Input()
  direction: 'row' | 'row-reverse' | 'column' | 'column-reverse' = 'row';

  @Input()
  gap = '1em';

  @Input()
  wrap: 'wrap' | 'no-wrap' | 'wrap-reverse' = 'wrap';

  @Input()
  justify: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' = 'flex-start';

  constructor(private sanitizer: DomSanitizer) {}
}
